export const getUuid = (): string => {
  return crypto.randomUUID()
}
